import { Button } from '@mui/material';
import { bool, object } from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'utils/i18n';
import connector from './connector';

class ArchivedChannelsButton extends Component {
  shouldComponentUpdate(nextProps) {
    const { showArchived } = this.props;
    return showArchived !== nextProps.showArchived;
  }

  handleClick = () => {
    const { actions } = this.props;
    actions.channelsPanel.showArchived(true);
  };

  render() {
    const { showArchived } = this.props;
    if (showArchived) {
      return null;
    }
    return (
      <Button
        onClick={this.handleClick}
        color="primary"
        fullWidth
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          borderRadius: 0,
          color: 'secondary.dark',
        }}
      >
        {I18n.t('ChannelsPanel.Archived chats')}
      </Button>
    );
  }
}

ArchivedChannelsButton.propTypes = {
  actions: object.isRequired,
  showArchived: bool.isRequired,
};

export default connector(ArchivedChannelsButton);
